import InstructionWidget
  from "./InstructionWidget";

export default InstructionWidget;   